import { setTabById } from '../../../../design3/asset-build/js/custom/fullscreenTabContainer';
import { getHashProperty } from '../../../../design3/asset-build/js/custom/_utils';
const cssClass = 'FullscreenTabContainer';

const selectors = {
	tabContainer: `.${cssClass}`,
	tab: `.${cssClass}-tab`,
	activeTab: `.${cssClass}-tab--active`,
};
let hashProperty;

const setHashUrl = id => {
	let hashParam = id ? `#${id}` : '';
	window.history.replaceState(
		'',
		document.title,
		`${window.location.href.split('#')[0]}${hashParam}`
	);
};

export default function initPrivateJetDestinations() {
	const $tabContainer = $(selectors.tabContainer);
	hashProperty = getHashProperty();

	window.addEventListener('tabContainerReady', () => {
		if (hashProperty) {
			const $tab = $tabContainer.find(`${selectors.tab}[data-id=${hashProperty}]`);
			if ($tab && $tab.length > 0) {
				//found the matching id
				setTabById($tabContainer, hashProperty);
			}
		} else {
			setHashUrl($tabContainer.find(selectors.activeTab).data('id'));
		}

		$tabContainer.find(selectors.tab).on('click', e => {
			setHashUrl($(e.currentTarget).data('id'));
		});
	});
}
